export default __webpack_public_path__ + "static/og-image-73a21e3f6e1ec8a778d9c40f5c31e991.jpg";